var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry"},[_c('Menu'),_c('Tabber',{attrs:{"tabberData":_vm.tabberData,"activeIndex":_vm.activeIndex,"tabTitle":_vm.tabTitle},on:{"changeTabber":_vm.changeTabber}},[_c('div',{ref:"tabberContent",staticClass:"box",attrs:{"slot":"tabberContent"},slot:"tabberContent"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }